import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { SSRGetDoneMark } from '../helper/ssr-get-done-mark';
import { PageSegmentPageLoadMetricsOptions } from '../types';
import { MetricState } from './base-metric';
import { Metric } from './metric';
import { pageLoadMetaMetric } from './page-load-meta-metric';
export var PageSegmentLoadMetric = /*#__PURE__*/function (_Metric) {
  _inherits(PageSegmentLoadMetric, _Metric);
  var _super = _createSuper(PageSegmentLoadMetric);
  function PageSegmentLoadMetric(config) {
    var _this;
    _classCallCheck(this, PageSegmentLoadMetric);
    _this = _super.call(this, config);
    _defineProperty(_assertThisInitialized(_this), "isInitial", true);
    _this.config = config;
    return _this;
  }
  _createClass(PageSegmentLoadMetric, [{
    key: "startFromPageLoad",
    value: function startFromPageLoad() {
      var _pageLoadMetaData$sta;
      var pageLoadMetaData = pageLoadMetaMetric.getData();
      this.start({
        startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
      });
      this.isInitial = pageLoadMetaData.isInitial;
      this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
  }, {
    key: "mark",
    value: function mark(_mark) {
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
      if (_mark === PageSegmentLoadMetric.FMP) {
        return;
      }
      _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "mark", this).call(this, _mark, timestamp);
    }
  }, {
    key: "markFMP",
    value: function markFMP(timestamp) {
      _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "mark", this).call(this, PageSegmentLoadMetric.FMP, timestamp);
    }
  }, {
    key: "getPageSegmentLoadData",
    value: function getPageSegmentLoadData() {
      return {
        isInitial: this.isInitial
      };
    }
  }, {
    key: "getData",
    value: function getData() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "getData", this).call(this)), this.getPageSegmentLoadData());
    }
  }, {
    key: "getDataToMerge",
    value: function getDataToMerge() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "getDataToMerge", this).call(this)), this.getPageSegmentLoadData());
    }
  }, {
    key: "merge",
    value: function merge(mergeData) {
      _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "merge", this).call(this, mergeData);
      this.isInitial = mergeData.isInitial;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$config$ssr,
        _this2 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pageLoadData = pageLoadMetaMetric.getData();
      if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
        if (!this.marks[PageSegmentLoadMetric.FMP]) {
          var mark = SSRGetDoneMark.getDoneMark();
          if (mark) {
            this.markFMP(mark);
          }
        }
      }
      if (this.config.includePageLoadTimings !== PageSegmentPageLoadMetricsOptions.WAIT_UNTIL_PRESENT || pageLoadData.state === MetricState.FINISHED) {
        return _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "stop", this).call(this, params);
      }
      var now = performance.now();
      if (pageLoadData.state === MetricState.STARTED) {
        pageLoadMetaMetric.onStop(function () {
          _get(_getPrototypeOf(PageSegmentLoadMetric.prototype), "stop", _this2).call(_this2, _objectSpread(_objectSpread({}, params), {}, {
            stopTime: params.stopTime || now
          }));
        }, function () {
          _this2.cancel();
        });
      }
      return true;
    }
  }]);
  return PageSegmentLoadMetric;
}(Metric);
_defineProperty(PageSegmentLoadMetric, "FMP", 'fmp');